import { fetchingProduct } from "../../helpers/fetchingProduct";

class ProductSelector {
  constructor() {
    this.selectors = {
      container: document.querySelector(".select-products"),
      titleOne: document.querySelector(".select-products__title--one"),
      titleTwo: document.querySelector(".select-products__title--two"),
      productsWrapper: document.querySelector(".select-products__products"),
      productsListOne: document.querySelector(".select-products__ul--one"),
      productsListTwo: document.querySelector(".select-products__ul--two"),
      purchaseTitle: document.querySelector(".select-products__bottom--title"),
      contentInfo: document.querySelector(".select-products__bottom--content"),
      bottomWrapper: document.querySelector(
        ".select-products__wrapper--bottom"
      ),
    };

    if (!this.selectors.container) return;

    this.hasListOne = !!this.selectors.productsListOne;
    this.hasListTwo = !!this.selectors.productsListTwo;

    this.initEvents();
    this.currentSelectedList = null;
    this.initVariantDropdowns();
  }

  initEvents() {
    if (this.selectors.titleOne && this.hasListOne) {
      this.selectors.titleOne.addEventListener("click", () => {
        if (this.hasListTwo) {
          this.toggleProductList(
            this.selectors.productsListTwo,
            this.selectors.productsListOne
          );
        } else {
          this.toggleSingleList(this.selectors.productsListOne);
        }
      });
    }

    if (this.selectors.titleTwo && this.hasListTwo) {
      this.selectors.titleTwo.addEventListener("click", () => {
        if (this.hasListOne) {
          this.toggleProductList(
            this.selectors.productsListOne,
            this.selectors.productsListTwo
          );
        } else {
          this.toggleSingleList(this.selectors.productsListTwo);
        }
      });
    }
  }

  toggleSingleList(list) {
    if (!list) return;

    list.classList.toggle("isOpen");

    if (this.selectors.productsWrapper) {
      this.selectors.productsWrapper.classList.toggle("isOpen");
    }

    this.handleProductVariants(list);
    this.currentSelectedList = list;
  }

  toggleProductList(listToShow, listToHide) {
    if (!listToShow || !listToHide) return;

    if (listToHide.classList.contains("isOpen")) {
      listToHide.classList.remove("isOpen");
    }

    if (this.selectors.productsWrapper) {
      this.selectors.productsWrapper.classList.toggle(
        "isOpen",
        !listToShow.classList.contains("isOpen")
      );
    }

    listToShow.classList.toggle("isOpen");
    this.handleProductVariants(listToShow);
    this.currentSelectedList = listToShow;
  }

  initVariantDropdowns() {
    const dropdowns = document.querySelectorAll(".variant-dropdown");
    if (!dropdowns.length) return;

    dropdowns.forEach((dropdown) => {
      dropdown.addEventListener("change", (e) => {
        const selectedVariantId = e.target.value;
        const productItem = e.target.closest(".select-products__li");

        if (!productItem) return;

        productItem.setAttribute("product-id", selectedVariantId);

        const selectedOption = e.target.options[e.target.selectedIndex];
        const priceText = selectedOption?.text.split(" - ")[1];
        const priceElement = productItem.querySelector(".select-products__p");

        if (priceElement && priceText) {
          priceElement.textContent = priceText.replace(" (Agotado)", "");
        }

        if (productItem.classList.contains("select")) {
          const productData = {
            id: selectedVariantId,
            title: productItem.querySelector(".select-products__h3")
              ?.textContent,
            price: priceElement?.textContent,
            image: productItem.querySelector("img")?.src,
            variants: productItem.querySelector(".product-variant-selector"),
            currentVariantId: selectedVariantId,
          };
          this.updateProductInfo(productData);
        }
      });
    });
  }

  handleProductVariants(container) {
    if (!container) return;

    const variants = container.querySelectorAll("li");
    if (!variants.length) return;

    variants.forEach((variant) => {
      variant.removeEventListener("click", this.variantClickHandler);
      this.variantClickHandler = this.handleVariantClick.bind(this);
      variant.addEventListener("click", this.variantClickHandler);
    });
  }

  handleVariantClick(event) {
    const variant = event.currentTarget;
    const variants = variant.parentElement.querySelectorAll("li");

    variants.forEach((v) => v.classList.remove("select"));
    variant.classList.add("select");

    const productData = {
      id: variant.getAttribute("product-id"),
      title: variant.querySelector(".select-products__h3")?.textContent,
      price: variant.querySelector(".select-products__p")?.textContent,
      image: variant.querySelector("img")?.src,
      variants: variant.querySelector(".product-variant-selector"),
      currentVariantId: variant.getAttribute("product-id"),
    };

    this.updateProductInfo(productData);
  }

  updateProductInfo({ image, title, price, id, variants, currentVariantId }) {
    const { purchaseTitle, contentInfo } = this.selectors;

    if (!purchaseTitle || !contentInfo) return;

    purchaseTitle.style.display = "none";
    contentInfo.style.display = "flex";

    const infoElements = {
      title: contentInfo.querySelector(".select-products__info--title"),
      image: contentInfo.querySelector("img"),
      price: contentInfo.querySelector(".select-products__info--price"),
      button: contentInfo.querySelector(".add-to-cart"),
      variantContainer: contentInfo.querySelector(
        ".select-products__info--vars"
      ),
    };

    if (!infoElements.title || !infoElements.button) return;

    infoElements.title.textContent = title || "";

    if (infoElements.image) {
      infoElements.image.src = image || "";
    }

    infoElements.button.setAttribute("data-product-id", id || "");

    if (variants && infoElements.variantContainer) {
      const variantsClone = variants.cloneNode(true);
      infoElements.variantContainer.innerHTML = "";
      infoElements.variantContainer.appendChild(variantsClone);

      if (infoElements.price) {
        infoElements.price.style.display = "none";
      }

      const dropdown = variantsClone.querySelector(".variant-dropdown");
      if (dropdown) {
        dropdown.value = currentVariantId || id;

        dropdown.addEventListener("change", (e) => {
          const value = e.target.value;
          infoElements.button.setAttribute("data-product-id", value);
        });
      }
    } else {
      if (infoElements.price) {
        infoElements.price.textContent = price || "";
        infoElements.price.style.display = "block";
      }
      if (infoElements.variantContainer) {
        infoElements.variantContainer.innerHTML = "";
      }
    }
    infoElements.button.setAttribute("data-product-id", id || "");
    infoElements.button.addEventListener("click", () =>
      this.handleAddToCart(id)
    );
  }

  async handleAddToCart(productId) {
    if (!productId) return;

    try {
      await fetchingProduct("/cart/add.js", "POST", "id", productId, 1);
      window.location.href = "/checkout";
    } catch (error) {
      console.error("Error al añadir producto:", error.message);
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector(".select-products")) {
    new ProductSelector();
  }
});
